import { useState } from "react";
import { Link } from "react-router-dom";
import classes from "./index.module.scss";
import btnClasses from "../Button.module.scss";
import checkboxClasses from "../Checkbox.module.scss";

export default function Mailchimp({
  id,
  btnText,
  btnDataContent = "Subscribe",
  formID = "45d28f304740b7e895a0adcae",
  theme = null,
}) {
  const [fields, setFields] = useState({
    EMAIL: "",
    FNAME: "",
    LNAME: "",
  });

  const [checked, setChecked] = useState(false);
  const validateEmail = (email) => {
    return !!String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const onInputChange = (e) => {
    setFields((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const onCheckboxChange = (e) => {
    setChecked(e.target.checked);
  };

  return (
    <div id="mc_embed_signup">
      <form
        action={`https://engenious.us12.list-manage.com/subscribe/post?u=${formID}&amp;id=${id}`}
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        className="validate"
        target="_blank"
        noValidate
      >
        <div id="mc_embed_signup_scroll" className={classes["form-inner"]}>
          <div className={`${classes["mc-field-group"]} mc-field-group`}>
            <input
              type="text"
              value={fields.firstName}
              name="FNAME"
              className={`${classes.input}`}
              id="mce-FNAME"
              placeholder="First Name"
              onChange={onInputChange}
            />
            <input
              type="text"
              value={fields.lastName}
              name="LNAME"
              className={`${classes.input}`}
              id="mce-LNAME"
              placeholder="Last Name"
              onChange={onInputChange}
            />
            <input
              type="email"
              value={fields.email}
              name="EMAIL"
              className={`${classes.input} required email`}
              id="mce-EMAIL"
              onChange={onInputChange}
              placeholder="Email"
            />
            <div className={classes["checkbox"]}>
              <input
                readOnly
                className={`${checkboxClasses.checkbox} ${
                  theme ? checkboxClasses["checkbox_" + theme] : ""
                }`}
                type="checkbox"
                id="custom-checkbox"
                name="custom-checkbox"
                value="custom-checkbox"
                checked={checked}
                onChange={onCheckboxChange}
              />
              <label htmlFor="custom-checkbox">
                I have read and agree to the&nbsp;
                <Link
                  className={`${checkboxClasses.link} ${
                    theme ? checkboxClasses["link_" + theme] : ""
                  }`}
                  to="/privacy-policy"
                >
                  Privacy Policy
                </Link>
              </label>
            </div>
          </div>
          <div id="mce-responses" className="clear">
            <div
              className="response"
              id="mce-error-response"
              style={{ display: "none" }}
            ></div>
            <div
              className="response"
              id="mce-success-response"
              style={{ display: "none" }}
            ></div>
          </div>
          <div
            style={{ position: "absolute", left: "-5000px" }}
            aria-hidden="true"
          >
            <input
              readOnly
              type="text"
              name={`b_${formID}_${id}`}
              tabIndex="-1"
              value=""
            />
          </div>
          <div className="clear">
            <button
              disabled={!checked || !validateEmail(fields.EMAIL)}
              type="submit"
              value={btnText}
              name="subscribe"
              id="mc-embedded-subscribe"
              className={`${btnClasses.button} ${
                theme ? btnClasses["button_" + theme] : ""
              }`}
              data-content={btnDataContent}
            >
              {btnText}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
